import { Box, Card, Grid, styled, useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import ReversePagination from '../../../components/ReversePagination';
import MyPostsItem from './MyPostsItem';

const MyPostSection = ({
  isTablet,
  isMobile,
  postsData = [],
  title = '북마크한 게시글',
  icon = '/static/icons/best.png',
  filterItems = ['전체', '자유게시판', '질문답변', '정보공유', '후기', '모임'],
  onAIRecommendClick,
  onCardClick,
  showAIRecommendButton = false,
  ...props
}) => {
  const navigate = useNavigate();
  const theme = useTheme();

  const handleCardClick = item => {
    if (onCardClick) {
      onCardClick(item);
    } else {
      navigate('/callmetellme/community/community-detail');
    }
  };

  // Default posts data if none provided
  const defaultPostsData = [
    {
      id: 1,
      title: '안녕하세요 화이팅입니다~~~~',
      category: '자유게시판',
      content:
        '세부 내용입니다 세부 내용입니다세부 내용입니다세부 내용입니다세부 내용입니다 세부 내용입니다세부 내용입니다 세부 내용입니다세부 내용입니다 세부 내용입니 세부 내용입니다 세부 내용입니다세부 내용입니다세부 내용입니다세부 내용입니다 세부 내용입니다세부 내용입니다 세부 내용입니다세부 내용입니다 세부 내용입니 세부 내용입니다 세부 내용입니다세부 내용입니다세부 내용입니다세부 내용입니다 세부 내용입니다세부 내용입니다 세부 내용입니다세부 내용입니다 세부 내용입니',
      thumbnail: '/static/post-image/post-1.png',
      starCount: 0,
      likeCount: 5,
      commentCount: 12,
      date: '2025.01.24',
    },
    {
      id: 2,
      title: '안녕하세요 화이팅입니다~~',
      category: '자유게시판',
      content:
        '세부 내용입니다 세부 내용입니다세부 내용입니다세부 내용입니다세부 내용입니다 세부 내용입니다세부 내용입니다 세부 내용입니다세부 내용입니다 세부 내용입니',
      thumbnail: '/static/post-image/post-2.png',
      starCount: 0,
      likeCount: 5,
      commentCount: 12,
      date: '2025.01.24',
    },
    {
      id: 3,
      title: '썸네일이 없는 게시글입니다',
      category: '질문답변',
      content:
        '이 게시글은 썸네일이 없어서 이미지 영역이 표시되지 않습니다. 텍스트만으로 구성된 게시글의 예시입니다.',
      // thumbnail: null, // explicitly no thumbnail
      starCount: 2,
      likeCount: 8,
      commentCount: 5,
      date: '2025.01.23',
    },
    {
      id: 4,
      title: '빈 썸네일 문자열 게시글',
      category: '정보공유',
      content:
        '빈 문자열로 설정된 썸네일을 가진 게시글입니다. 이런 경우에도 이미지가 표시되지 않아야 합니다.',
      thumbnail: '', // empty string thumbnail
      starCount: 1,
      likeCount: 3,
      commentCount: 7,
      date: '2025.01.22',
    },
  ];

  const dataToUse = postsData.length > 0 ? postsData : defaultPostsData;

  const StyledCard = styled(Card)(({ theme }) => ({
    width: '100%',
    padding: '0px 0px',
    backgroundColor: theme.palette.primary.lightGrey200,
    borderRadius: 0,
    border: 'none',
    [theme.breakpoints.down('sm')]: {
      '& > .MuiBox-root': {
        paddingBottom: 0,
      },
    },
  }));

  return (
    <StyledCard
      sx={{
        border: 'none',
        overflow: 'visible',
        ...props.sx,
      }}
    >
      <Box
        sx={{
          width: '100%',
        }}
      >
        {/* Header */}
        <Box
          sx={{
            backgroundColor: '#fff',
            padding: isMobile ? '18px' : '26px',
            borderRadius: '24px',
            boxShadow: '1px 4px 6px rgba(0, 0, 0, 0.05)',
          }}
        >
          {/* 커뮤니티 포스트 카드 */}
          <Grid container spacing={1} pt={2}>
            {dataToUse.map((item, index) => (
              <MyPostsItem
                key={item.id}
                item={item}
                onClick={handleCardClick}
              />
            ))}

            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                mt: 2,
                width: '100%',
              }}
            >
              <ReversePagination totalItems={3} />
            </Box>
          </Grid>
        </Box>
      </Box>
    </StyledCard>
  );
};

export default MyPostSection;
